import type { IKioskScreenSaverConfig, IKioskScreenSaverImage } from "@/data/model/Kiosk";



import { BaseServiceDao, parseCollection } from "./BaseServiceDao";
import type { IGetScreenSaverConfigQry } from "@/data/queries/kiosk/GetScreenSaverConfigQry";


export class KioskDao extends BaseServiceDao {
    public static className = "KioskDao";

    constructor() {
        super("kiosk");
    }

    public async getScreenSaverConfig(cmd: IGetScreenSaverConfigQry): Promise<IKioskScreenSaverConfig> {
        return this.get("screen-saver-config", cmd, KioskDao.parseScreenSaverConfig);
    }

    private static parseScreenSaverConfig(literal: any): IKioskScreenSaverConfig {
        return {
            images: parseCollection(literal.images, KioskDao.parseScreenSaverImage),
            transitionDelayMs: literal.transitionDelayMs,
        };
    }

    private static parseScreenSaverImage(literal: any): IKioskScreenSaverImage {
        return {
            imageOrder: literal.imageOrder,
            imagePath: literal.imagePath,
        };
    }
}